import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CheckBoxIcon = ({
  height = normalize(40),
  width = normalize(40),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 40 40"
    preserveAspectRatio="xMidYMin meet"
  >
    <Path
      d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
      fill="white"
    />
    <Path
      d="M23.6048 14.932C23.5141 14.8603 23.4101 14.8072 23.2989 14.7758C23.1876 14.7444 23.0712 14.7354 22.9564 14.7492C22.8416 14.7631 22.7307 14.7995 22.6301 14.8564C22.5294 14.9134 22.441 14.9896 22.3701 15.0809L16.2403 22.962L13.2367 19.3017C13.1662 19.2079 13.0777 19.1292 12.9762 19.0703C12.8748 19.0114 12.7625 18.9735 12.6462 18.9589C12.5298 18.9442 12.4117 18.953 12.2988 18.9849C12.1859 19.0167 12.0805 19.0709 11.989 19.1443C11.8975 19.2176 11.8216 19.3086 11.7659 19.4119C11.7102 19.5151 11.6758 19.6285 11.6648 19.7452C11.6537 19.862 11.6663 19.9798 11.7016 20.0917C11.737 20.2035 11.7945 20.3071 11.8706 20.3963L15.5222 24.9323C15.6046 25.0339 15.7088 25.1158 15.827 25.1718C15.9452 25.2279 16.0744 25.2568 16.2053 25.2563C16.3441 25.2625 16.4825 25.2356 16.6089 25.1777C16.7352 25.1198 16.846 25.0327 16.9321 24.9236L23.7887 16.1667C23.8586 16.0739 23.9093 15.9682 23.9379 15.8556C23.9665 15.743 23.9725 15.6258 23.9553 15.5109C23.9382 15.396 23.8984 15.2856 23.8382 15.1862C23.778 15.0868 23.6987 15.0004 23.6048 14.932ZM27.9832 14.932C27.8925 14.8603 27.7886 14.8072 27.6773 14.7758C27.566 14.7444 27.4496 14.7354 27.3348 14.7492C27.22 14.7631 27.1091 14.7995 27.0085 14.8564C26.9078 14.9134 26.8195 14.9896 26.7485 15.0809L20.6187 22.962L20.0845 22.3053L18.9812 23.7239L19.9444 24.9236C20.0268 25.0252 20.131 25.107 20.2492 25.1631C20.3674 25.2191 20.4966 25.248 20.6274 25.2476C20.759 25.247 20.8887 25.2167 21.0069 25.1591C21.1252 25.1015 21.2289 25.018 21.3105 24.9148L28.1671 16.158C28.2356 16.0655 28.2852 15.9603 28.3131 15.8486C28.3409 15.7369 28.3465 15.6207 28.3294 15.5069C28.3123 15.393 28.2729 15.2836 28.2135 15.185C28.1541 15.0863 28.0758 15.0004 27.9832 14.932Z"
      fill="#276DB2"
    />
    <Path
      d="M16.6782 20.9302L17.8078 19.5116L17.6327 19.3014C17.5636 19.2056 17.4758 19.1248 17.3746 19.0639C17.2734 19.0029 17.161 18.963 17.044 18.9467C16.927 18.9303 16.8079 18.9378 16.6939 18.9687C16.5798 18.9995 16.4732 19.0531 16.3805 19.1263C16.2905 19.1985 16.2157 19.2879 16.1604 19.3891C16.1051 19.4904 16.0703 19.6016 16.0581 19.7163C16.0459 19.8311 16.0565 19.9471 16.0893 20.0577C16.1221 20.1683 16.1764 20.2714 16.2491 20.361L16.6782 20.9302Z"
      fill="#276DB3"
    />
  </Svg>
);

export default CheckBoxIcon;
